/** Used for mapping reserved mqtt operation kind */
export enum GenericOperationKind {
  NONE = 0,
  INSERT = 1,
  UPDATE = 2,
  DELETE = 3,
  CARD_WRITE = 100,
  CARD_READ = 101,
  CARD_BLANK = 102,
  CARD_CLONE = 103,
  CARD_COPY = 104,
  CARD_ACTIVATE = 105,
  CARD_DEACTIVATE = 106,
  CARD_BLOCK = 107,
  CARD_UNBLOCK = 108,
  CARD_REMOVE = 109,
  CARD_INSERT = 110,
  CARD_EDIT = 111,
  CARDENVIRONMENT_ADD = 112,
  CARDENVIRONMENT_REMOVE = 113,
  CARD_TEMPLATE_CHANGE = 114,
  CARD_ACCESS_ALLOW = 150,
  CARD_ACCESS_DENY = 151,
  CUSTOMERSTAFF_BLOCK = 200,
  CUSTOMERSTAFF_UNBLOCK = 201,
  CUSTOMERSTAFF_CHANGE = 202,
  CUSTOMERSTAFF_REMOVE = 203,
  RESERVATION_CHECK_IN = 250,
  RESERVATION_CHECK_OUT = 251,
  RESERVATION_CHANGE = 252,
  RESERVATION_INSERT = 253,
  CARDENVIRONMENT_TIMESLOT_CHANGE = 300,
  CARDENVIRONMENT_CALENDAR_CHANGE = 400,
}
